module.exports = __webpack_public_path__ + "static/media/welcome-modal-immediate-support.283062fc.jpg";